module.exports = __webpack_public_path__ + "img/p9-p1-bg.b3ede6d0.jpg";